var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayout = function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B1B1B3",
    fillRule: "evenodd",
    d: "M17.084 6.09v7.82q0 .623-.452 1.064a1.5 1.5 0 0 1-1.087.443H4.455q-.633 0-1.086-.443a1.44 1.44 0 0 1-.452-1.064V6.09q0-.621.452-1.064a1.5 1.5 0 0 1 1.087-.442h11.09q.635 0 1.086.442.452.443.452 1.064M4.167 10h7.39V5.834H4.456a.3.3 0 0 0-.2.08q-.09.08-.089.176zm8.64 4.167h2.738a.3.3 0 0 0 .2-.08.24.24 0 0 0 .089-.177V6.09q0-.096-.088-.176a.3.3 0 0 0-.2-.08h-2.74zm-8.351 0h7.101V11.25h-7.39v2.66q0 .097.088.177a.3.3 0 0 0 .2.08",
    clipRule: "evenodd"
  })));
};
export default SvgLayout;